import React, { useEffect } from "react";

function PrivacyPolicy() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, {});

  return (
    <div className="service">
      {/* Header Section */}
      <div className="container-fluid page-header py-5" style={{ backgroundColor: "var(--bs-primary)" }}>
        <div className="container text-center py-5">
          <h1 className="display-2 text-white mb-4 animated slideInDown">
            Privacy Policy
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <a href="/" className="text-white">Home</a>
              </li>
              <li className="breadcrumb-item text-white active" aria-current="page">
                Privacy Policy
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Content Section */}
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-10 mx-auto">
            
            {/* Effective Date */}
            <p className="text-muted mb-4">
              <strong>Effective Date:</strong> 01/08/2025
            </p>

            {/* Introduction */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">1. Introduction</h3>
              <p className="text-muted">
                At <strong>Unigenius Ltd</strong> (“Unigenius”, “we”, “our”, or “us”), we are committed to safeguarding the privacy and personal data of every individual who interacts with us. This Privacy Policy explains in detail how we collect, use, store, share, and protect the personal information that you provide to us, whether you do so in person, over the phone, through email, on our website, or via social media channels. We take our responsibilities under the UK General Data Protection Regulation (UK GDPR), the Data Protection Act 2018, and all other applicable privacy laws very seriously.
              </p>
              <p className="text-muted">
                We understand that when you choose to share your personal details with us, you place a significant level of trust in our organisation. In return, we believe you have the right to know exactly how we use that information, how we protect it, and what rights you have in relation to it.
              </p>
            </div>

            {/* Information Collection */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">2. Information We Collect</h3>
              <p className="text-muted">
                When you interact with Unigenius, you may share with us a variety of personal details. This can happen when you contact us to enquire about our services, complete an application for university or college admission, register for an event, sign up for a funding or visa consultation, or simply connect with us online.
              </p>
              <p className="text-muted">The types of personal data we may collect include:</p>
              <ul className="text-muted ps-3">
                <li>Full name, date of birth, address, email address, and telephone number.</li>
                <li>Education history and employment history.</li>
                <li>Passport and visa information (in certain cases).</li>
                <li>Sensitive information (e.g., health or nationality) only when necessary for legal requirements or admissions.</li>
              </ul>
            </div>

            {/* How We Collect Information */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">3. How We Collect Your Information</h3>
              <p className="text-muted">
                Your information is collected in several ways. Sometimes you provide it directly, for example when filling out an application form or sending us an email. Other times, we may receive your details from trusted third parties, such as universities, education agents, employers, or funding bodies, but only when you have given your consent or when the law permits them to share that data with us. Whenever we obtain information in this way, we ensure that it is handled with the same care and respect as if you had provided it to us yourself.
              </p>
            </div>

            {/* Use of Data */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">4. How We Use Your Data</h3>
              <p className="text-muted">
                The personal data we collect is used for specific purposes, including:
              </p>
              <ul className="text-muted ps-3">
                <li>Processing and managing applications for study.</li>
                <li>Securing funding or finance through Student Finance England or equivalent bodies.</li>
                <li>Guiding you through the visa process.</li>
                <li>Providing personalised advice and guidance.</li>
                <li>Fulfilling contractual obligations and legal requirements.</li>
                <li>Keeping you updated with relevant opportunities (based on your preferences).</li>
              </ul>
              <p className="text-muted">
                Your information will never be used for purposes that are incompatible with the reason it was collected, and we will always inform you if the purpose changes.
              </p>
            </div>

            {/* Data Security */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">5. Data Security</h3>
              <p className="text-muted">
                We are committed to protecting the security of your personal data. All information you provide to us is stored securely, either on protected on-site systems or within cloud-based platforms that meet strict UK GDPR compliance standards. Access to this information is strictly limited to authorised members of staff who require it to perform their duties. We have in place both technical and organisational safeguards to prevent unauthorised access, disclosure, or loss of your data.
              </p>
            </div>

            {/* Data Retention */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">6. Data Retention</h3>
              <p className="text-muted">
                We retain your personal information only for as long as necessary to fulfil the purposes for which it was collected, including satisfying any legal, accounting, or reporting requirements. In most cases, this will be a period of up to six years from your last interaction with us, though certain types of information may be held for longer if required by law or regulatory obligations. Once the retention period has expired, your data will be securely deleted or anonymised.
              </p>
            </div>

            {/* Sharing Data */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">7. Sharing Your Information</h3>
              <p className="text-muted">
                There are circumstances in which we may share your personal data with others, including:
              </p>
              <ul className="text-muted ps-3">
                <li>Partner universities, colleges, or training providers (for application processing).</li>
                <li>Immigration authorities (for visa applications).</li>
                <li>Funding bodies such as Student Finance England.</li>
                <li>Trusted third-party service providers (IT support, marketing agencies, professional advisers).</li>
              </ul>
              <p className="text-muted">
                In all such cases, we require these third parties to comply with data protection laws and to use your personal data only for the specific purposes for which it was provided.
              </p>
            </div>

            {/* International Transfers */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">8. International Transfers</h3>
              <p className="text-muted">
                If your data needs to be transferred outside the UK or the European Economic Area (EEA), we will ensure that it is subject to appropriate safeguards, such as approved contractual clauses or certification under an approved data protection framework. This ensures that your information remains protected to the same high standards regardless of where it is processed.
              </p>
            </div>

            {/* User Rights */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">9. Your Rights</h3>
              <p className="text-muted">
                Under UK GDPR, you have important rights regarding your data:
              </p>
              <ul className="text-muted ps-3">
                <li>Right to request access to the personal data we hold about you.</li>
                <li>Right to request corrections to inaccurate or incomplete data.</li>
                <li>Right to request the deletion of your personal information.</li>
                <li>Right to restrict or object to certain types of processing.</li>
                <li>Right to obtain a copy of your personal data for reuse.</li>
                <li>Right to withdraw consent for marketing communications at any time.</li>
              </ul>
            </div>

            {/* Marketing */}
            <div className="mb-5">
              <h3 className="mb-3 text-primary">10. Marketing Communications</h3>
              <p className="text-muted">
                We may occasionally use your contact information to send details about courses, funding opportunities, or services that may be relevant to you. We will only do so when you have given your explicit consent or where we have a legitimate business interest. You can unsubscribe from such communications easily by following the instructions in our emails or by contacting us directly.
              </p>
            </div>

            {/* Contact & Complaints */}
            <div className="mb-5 p-4 bg-light rounded shadow-sm">
              <h3 className="mb-3 text-primary">11. Contact Us & Complaints</h3>
              <p className="text-muted">
                If you ever have any concerns or questions about how we use your personal data, you can contact us directly.
              </p>
              <p className="mb-1"><strong>Unigenius Ltd</strong></p>
              <p className="mb-1">205 Kings Road, Birmingham, B11 2AA, United Kingdom</p>
              <p className="mb-1"><strong>Email:</strong> <a href="mailto:Info@unigenius.uk">Info@unigenius.uk</a></p>
              <p className="mb-3"><strong>Phone:</strong> 0121 492 0555</p>
              <p className="text-muted mb-0">
                If you are not satisfied with how we handle your data, you also have the right to lodge a complaint with the UK’s Information Commissioner’s Office via <a href="https://www.ico.org.uk" target="_blank" rel="noreferrer">www.ico.org.uk</a>.
              </p>
            </div>

            {/* Acceptance */}
            <div className="mb-5">
              <p className="text-muted fst-italic">
                By continuing to use our services, you acknowledge that you have read and understood this Privacy Policy and agree to the collection and use of your personal information in the ways described here. We may update this policy from time to time, and any changes will be posted on our website with an updated effective date. We encourage you to review this Privacy Policy regularly to stay informed about how we are protecting your information.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;